import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";
import { api } from "../../common/setupApi";

export const getInjuries = createAsyncThunk(
  "injuries/get",
  async (_, { rejectWithValue }) => {
    return api
      .get("injuries/")
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return rejectWithValue(err.response?.data);
      });
  },
  {
    condition: (params, { getState }) => {
      if (params?.ignoreCondition) {
        return true;
      }
      // https://redux-toolkit.js.org/api/createAsyncThunk#canceling-before-execution
      const { status } = selectInjuries(getState());
      if (status === "fulfilled" || status === "pending") {
        // Already fetched or in progress, don't need to re-fetch
        return false;
      }
    },
  }
);

const initialState = {
  status: "idle",
  data: [],
  error: null,
};

const injuriesSlice = createSlice({
  name: "injuries",
  initialState,
  reducers: {
    add: (state, action) => {
      state.data.push(action.payload);
    },
    set: (state, action) => {
      state.data = state.data.map((d) =>
        d.id === action.payload.id ? action.payload : d
      );
    },
    delete: (state, action) => {
      state.data = state.data.filter((d) => d.id !== action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getInjuries.pending, (state) => {
        state.status = "pending";
        state.error = null;
      })
      .addCase(getInjuries.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.data = action.payload;
      })
      .addCase(getInjuries.rejected, (state, action) => {
        state.status = "rejected";
        state.error = action.payload;
      })
      .addCase("auth/logout", () => initialState);
  },
});

export const injuriesActions = injuriesSlice.actions;

const _selectInjuries = (state) => state.injuries;

export const selectInjuries = createSelector(
  [(state) => _selectInjuries(state)],
  (injuries) => {
    const data = injuries.data;
    const status = injuries.status;
    const error = injuries.error;
    const isLoading = status === "pending";
    return { data, status, error, isLoading };
  }
);

export default injuriesSlice.reducer;
